import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import './index.css';
import './evaporar.css';
import './boton.css';

import { useScrollPositionInRef } from '../../components/hooks/useScrollPositionInRef';
import { useRelativeTop } from '../../components/hooks/useRelativeTop';
import { useWindowSize } from '../../components/hooks/useWindowSize';
import { useMediaQuery } from '../../components/hooks/useMediaQuery';
import SocialLinks from '../../components/controls/SocialLinks';
import InstagramCarousel from '../../components/controls/InstagramCarousel';


function HomeView() {

    const isMobile = useMediaQuery("(max-width: 768px)");
    const isTablet = useMediaQuery("(max-width: 1024px)");
    
    const containerRef = useRef(null);
    const childRef1 = useRef(null);
    const childRef3 = useRef(null);
    const childRef5 = useRef(null);
    const childRef7 = useRef(null);

    const relativeTop1 = useRelativeTop(containerRef, childRef1);
    const relativeTop3 = useRelativeTop(containerRef, childRef3);
    const relativeTop5 = useRelativeTop(containerRef, childRef5);
    const relativeTop7 = useRelativeTop(containerRef, childRef7);

    const { scrollTop } = useScrollPositionInRef(containerRef);
    const { width, height } = useWindowSize();

    const dispatch = useDispatch();
    const {username} = useSelector( (state) => state.auth );
    const [indexBlock, setIndexBlock] = useState(0);

    useEffect(() => {
        if ((scrollTop??0) > 0) {
            if (relativeTop7 <= 0) {
                setIndexBlock(4)
            }
            else if (relativeTop5 <= 0) {
                setIndexBlock(3)
            }
            else if (relativeTop3 <= 0) {
                setIndexBlock(2)
            }
            else if (relativeTop1 <= 0) {
                setIndexBlock(1)
            }
            else {
                setIndexBlock(0)
            }
        }
        else {
            setIndexBlock(0)
        }
    }, [scrollTop])

    const posts = [
        {
            image: "../../images/post1.png",
            link: "https://www.instagram.com/p/DRxKn0_AEQa/"
        },
        {
            image: "../../images/post2.png",
            link: "https://www.instagram.com/p/DR2RsyTDKKT/"
        },
        {
            image: "../../images/post3.png",
            link: "https://www.instagram.com/p/DR5T8iJj2Sy/"
        },
        {
            image: "../../images/post4.png",
            link: "https://www.instagram.com/p/DSAhQFmkXc0/"
        },
        {
            image: "../../images/post5.png",
            link: "https://www.instagram.com/p/DSBOXRBkRd3/"
        },
        {
            image: "../../images/post6.png",
            link: "https://www.instagram.com/p/DSGRnMCFQkr/"
        },
        {
            image: "../../images/post7.png",
            link: "https://www.instagram.com/p/DSKw6rZjHLJ"
        },
        {
            image: "../../images/post8.png",
            link: "https://www.instagram.com/p/DSVq6yNiUVN"
        }
    ];

    return (
        <section className='home'>

            <div className='home-content'>

                <a href='#home-section'><img src='../../images/home.png' title='Volver al inicio' className='icon-float icon-home'></img></a>
                <a href='#search-section'><img src='../../images/search.png' title='Ver más información' className='icon-float icon-search'></img></a>
                <a href='#buy-section'><img src='../../images/buy.png' title='Dónde comprarlo' className='icon-float icon-buy'></img></a>
                <a href='#shared-section'><img src='../../images/shared.png' title='Dónde seguirlo' className='icon-float icon-shared'></img></a>
                <a href='../../doc/SAMPLER.pdf' target='_blank'><img src='../../images/download.png' title='Empeza a leerlo gratis' className='icon-float icon-download'></img></a>

                <div className='home-content-video'>
                    <video
                        src={`videos/video_${indexBlock}.mp4`}
                        autoPlay muted loop
                    />
                </div>

                <div className='home-background hidden-scroll' ref={containerRef}>

                    <a href='#search-section'>
                    <div id='home-section' className='home-block home-block-0 ' style={{height: height}}>
                        <div className='evaporar-box'>
                        <p className='evaporar'>La próxima gran aventura te está esperando</p>
                        </div>
                        <img className='scroll-down' src='../../images/scroll-down.gif' />
                    </div>
                    </a>

                    <div id='search-section' className='home-block home-block-1' style={{height: height}} ref={childRef1}>
                        <p><b>Corazón de guerrero</b></p>
                        <p>no es una novela más, sino el inicio de un viaje apasionante por un universo de fantasía épica</p>
                        <div className='row'>
                            <div className='col-12 col-lg-6 subtitle p-t-40'>
                                <div className='buy-links'>
                                    <div
                                        className='row'
                                        style={{width: isMobile ? 350 : 500}}
                                    >
                                        <div className='col-5'>
                                            <img
                                                src='../../images/book-mockup.jpg'
                                                className='book-mockup'
                                                style={{
                                                    // width: isMobile ? 350 : 500,
                                                    height: isMobile ? 200 : isTablet ? 250 : 300
                                                }}
                                            ></img>
                                        </div>
                                        <div className='col-7'>
                                            <div className='ta-row row'>
                                                <div className='col-12'>
                                                    <a href="../../doc/SAMPLER.pdf" target='_blank' className="btn btn--ghost">
                                                        Empezá a leerlo gratis
                                                    </a>
                                                </div>
                                                <div className='col-12'>
                                                    <a href="#buy-section" className="btn btn--solid">
                                                        Ya podés comprarlo
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='col-12 col-lg-6 subtitle p-t-40'>
                                <iframe
                                    width={isMobile ? 330 : 500}
                                    height={isMobile ? 200 : isTablet ? 250 : 300}
                                    src="https://www.youtube.com/embed/oDHPm1c1AzI"
                                    title="Booktrailer"
                                    frameborder="0"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                    allowfullscreen
                                ></iframe>
                            </div>
                        </div>
                    </div>
                    
                    <div className='home-block home-block-0' style={{height: height}}>
                        <p>Si te gusta el misterio, el suspenso</p>
                        <p>y los giros inesperados,</p>
                        <p>no te lo podes perder</p>
                    </div>

                    <div className='home-block home-block-1' style={{height: height}} ref={childRef3}>
                        <p>Ambientada en un mundo medieval fantástico, la novela entrelaza batallas épicas, antiguas maldiciones y la presencia del dragón, que dejará de ser leyenda para convertirse en parte de la realidad</p>
                    </div>

                    <div className='home-block home-block-0' style={{height: height}}>
                        <p>Si te apasionan las batallas medievales,</p>
                        <p>escenarios fantásticos y dragones,</p>
                        <p>seguro te va a encantar</p>
                    </div>

                    <div className='home-block home-block-1 sinopsis' style={{height: height}} ref={childRef5}>
                        <p><b>Te contamos un poco...</b></p>
                        <p><b>Eros</b> es un joven decidido a formar parte de la <b>Guardia Real</b> y defender el reino de las amenazas que se ciernen sobre sus tierras. Para lograrlo, deberá superar pruebas que pondrán en juego su coraje, su temple y hasta sus propios límites.</p>
                        <p>A pesar de su juventud, su valentía lo impulsará a emprender la temida travesía del <b>Camino de los miedos</b>, el lugar más oscuro y peligroso de <b>Tibur</b>, donde criaturas siniestras acechan bajo la maldición de los dioses. En ese recorrido no solo se forjará como guerrero, sino que iniciará un viaje de autodescubrimiento cuyas consecuencias marcarán el destino de todo el reino.</p>
                    </div>

                    <div className='home-block home-block-0' style={{height: height}}>
                        <p>Subite a esta aventura y vola hacia Tibur</p>
                    </div>

                    <div id='buy-section' className='home-block home-block-1' style={{height: height}} ref={childRef7}>
                        <p><b>Encontralo en digital y librerías</b></p>
                        <p className='puntos-venta'><a target="_blank" href="https://cuspide.com/producto/corazon-de-guerrero/">Cuspide</a></p>
                        <p className='puntos-venta'><a target="_blank" href="https://www.yenny-elateneo.com/productos/corazon-de-guerrero-qyjv3/">Yenny - El Ateneo</a></p>
                        <p className='puntos-venta'><a target="_blank" href="https://www.editorialbarenhaus.com/libros/biblioteca-de-autor/fantasia-biblioteca-de-autor/corazon-de-guerrero/">Bärenhaus - El guardían leterario</a></p>
                        <p className='puntos-venta'><a target="_blank" href="https://www.casadellibro.com/ebook-corazon-de-guerrero-ebook/9786316665225/17667861">Casa del libro</a></p>
                        <p className='puntos-venta'><a target="_blank" href="https://books.apple.com/cl/book/coraz%C3%B3n-de-guerrero/id6754947208">Apple Books</a></p>
                        <p className='puntos-venta'><a target="_blank" href="https://www.amazon.com/-/es/Gonzalo-Cajaraville-ebook/dp/B0FZY4YYSB/ref=sr_1_1?__mk_es_US=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=DLUA35SHKX7F&dib=eyJ2IjoiMSJ9.jrJWqQ5LcraywFoKSMHzKaGBOKHbBw5iIFMZudeORNA.5c2e15Cq6GyKaq9uohqVKh8t8ajpjxwOJdW_un9zqqI&dib_tag=se&keywords=gonzalo+cajaraville&qid=1764728113&sprefix=gonzalo+cajaravill%2Caps%2C251&sr=8-1">Amazon</a></p>
                        <p className='puntos-venta'><a target="_blank" href="https://play.google.com/store/books/details/Gonzalo_Cajaraville_Coraz%C3%B3n_de_guerrero?id=OAmWEQAAQBAJ">Google Play</a></p>
                    </div>

                    <div className='home-block home-block-0' style={{height: height}}>
                        <p>Acompañanos en este viaje</p>
                    </div>

                    <div id='shared-section' className='home-block home-block-1' style={{height: height}}>
                        <p className='no-indent'>No te pierdas nada</p>
                        <div className='row'>
                            <div className='col-12 col-md-6 subtitle p-t-20'>
                                <p className='no-indent'>Novedades</p>
                                <InstagramCarousel posts={posts}
                                    height={isMobile ? 250 : isTablet ? 350 : 400}
                                    width={isMobile ? 200 : isTablet ? 235 : 270}
                                />
                            </div>
                            <div className='col-12 col-md-6 subtitle p-t-20'>
                                <p className='no-wrap no-indent'>Seguinos en redes</p>
                                <div className="social-links">
                                <SocialLinks
                                    height={isMobile ? 220 : isTablet ? 350 : 400}
                                    width={isMobile ? 200 : isTablet ? 235 : 270}
                                />
                                </div>
                            </div>
                        </div>
                        
                    </div>

                </div>

            </div>

        </section>
    )
}

export default HomeView;
